import React, { useEffect } from 'react'
import './NewPayoutPage.scss'
import NewPayoutDetail from './NewPayoutDetail'
import { ExtendedContainer } from 'components/Grid'
import { useRouteMatch, useHistory } from 'react-router-dom'
import { URL_ACCOUNTING, URL_ACCOUNTING_PAYOUT } from 'urls'
import { Link } from 'react-router-dom'
import { ChevronDownSvg } from 'assets/svg'
import { useSelector } from 'react-redux'
import { isAuthenticated } from 'store/selectors'
import CreatorSidebar from 'components/CreatorSidebar'

const NewPayoutPage = () => {
  const {
    params: { payoutId },
  } = useRouteMatch()
  const history = useHistory()
  const hasAuth = useSelector((state) => isAuthenticated(state))

  useEffect(() => {
    if (!hasAuth) {
      history.push(
        `/sign-in?await_auth=true&redirect_url=${URL_ACCOUNTING_PAYOUT(
          payoutId
        )}`
      )
    }
  }, [history, hasAuth, payoutId])

  return (
    <CreatorSidebar>
      <div className="NewPayoutPage">
        <ExtendedContainer>
          <Link to={URL_ACCOUNTING} className="payout-title">
            <ChevronDownSvg className="payout-title-back" />
            Payout
          </Link>
          <NewPayoutDetail payoutId={payoutId} />
        </ExtendedContainer>
      </div>
    </CreatorSidebar>
  )
}

export default NewPayoutPage
